


































































































import DateMixin from "@/mixins/DateMixin";
import AccountIdValdationMixin from "@/mixins/AccountIdValdationMixin";
import { DalModule } from "@/store/dal.module";
import { Component, Mixins } from "vue-property-decorator";
import { translate } from "@/utils";
import MonthPicker from "@/components/ui/MonthPicker.vue";
import moment from "moment";
import { LocaleService } from "@/services/locale.service";
import { ReportsModule } from "@/store/reports.module";

@Component({
  components: { MonthPicker },
  watch: {
    serviceId: "loadData",
    "period.from": "loadData",
    "period.to": "loadData",
  },
})
export default class ServiceInfoView extends Mixins(
  DateMixin,
  AccountIdValdationMixin,
) {
  period = {
    from: "",
    to: "",
    min: "",
    max: "",
  };
  canLoad: boolean = false;
  get serviceId() {
    return DalModule.serviceId;
  }
  set serviceId(val) {
    DalModule.setServiceId(val);
  }

  async showPdf() {
    const locale = LocaleService.getLocale();
    await ReportsModule.generateReport({
      action: "open",
      path: `service-info-${locale}.prpt`,
      type: "pdf",
      filename: "filename",
      query: {
        Account_id: DalModule.AccountId,
        Service_id: this.serviceId,
        MonthFrom: moment(this.period.from).month() + 1,
        YearFrom: moment(this.period.from).year(),
        MonthTo: moment(this.period.to).month() + 1,
        YearTo: moment(this.period.to).year(),
        lang: locale == "ru" ? "rus" : "kaz",
      },
    });
  }
  get ST() {
    return translate(this.services);
  }

  get services() {
    return [
      {
        id: 13,
        name___ru: "Электроэнергия",
        name___kz: "Электр қуаты",
      },
      {
        id: 23,
        name___ru: "Электроэнергия в ноч. время",
        name___kz: "Түнгі уақ. электр қуаты",
      },
    ];
  }

  get payDate() {
    return DalModule.payDate;
  }

  get servicesListLoading() {
    return DalModule.servicesListLoading;
  }

  get serviceInfoList() {
    return DalModule.serviceInfoList;
  }

  get serviceInfoLength() {
    return DalModule.serviceInfoLength;
  }

  get headers() {
    return [
      {
        text: this.$t("service-info.year-month"),
        value: "monthYear",
      },
      {
        text: this.$t("service-info.begin-saldo"),
        value: "SUM_SALDO",
        align: "right",
      },
      {
        text: this.$t("service-info.calc"),
        value: "sum_calc",
        align: "right",
      },
      {
        text: this.$t("service-info.edits"),
        value: "EDIT_SUMM_CALC",
        align: "right",
      },
      {
        text: this.$t("service-info.pays"),
        value: "PAY_SUM",
        align: "right",
      },
      {
        text: this.$t("service-info.saldo"),
        value: "TOTAL_SUMM",
        align: "right",
      },
    ];
  }

  async mounted() {
    DalModule.setServiceInfoList();
    const today = new Date();
    this.period.to = moment(today).format("YYYY-MM");
    this.period.from = moment(today).add(-3, "M").format("YYYY-MM");
    this.period.min = moment(today).add(-35, "M").format("YYYY-MM");
    this.period.max = moment(today).format("YYYY-MM");
    await this.validateAccountId();
    if (!this.$route.params.id) {
      this.$router.push({ name: "account-list" });
      return;
    }
    const acc = Number.parseInt(this.$route.params.id);
    if (acc) {
      DalModule.setAccountId(acc);
    }
    await DalModule.getLastPayDate();
    this.canLoad = true;
    await this.loadData();
  }

  async loadData() {
    try {
      DalModule.setServicesListLoading(true);
      DalModule.setServiceInfoList();
      if (this.canLoad)
        await DalModule.getServiceInfo({
          Account_id: DalModule.AccountId,
          Service_id: this.serviceId,
          lang: LocaleService.getLocale() == "ru" ? "rus" : "kaz",
          MonthFrom: moment(this.period.from).month() + 1,
          YearFrom: moment(this.period.from).year(),
          MonthTo: moment(this.period.to).month() + 1,
          YearTo: moment(this.period.to).year(),
        });
    } finally {
      //
    }
  }
}
